import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const jpdPremiumOnboardingBannerEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-banner-jpd-premium-onboarding" */ './src/ui/banner/index.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
